/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var widgets = algolia.externals.widgets.dynamicWidgets;
  var queryRuleCustomData = algolia.externals.widgets.queryRuleCustomData;
  
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  let isMobile = false;
  var showingMobileView = false;

  function calculateScreenSize(){
    let mobile = false;
    if (window.matchMedia('(max-width: 1200px)').matches){
        mobile = true;
    }
    return mobile;
  }
  isMobile = calculateScreenSize();


  //start instant

  function renderInstantSearch(){

  showingMobileView = isMobile;
    
  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    poweredBy: algolia.config.powered_by,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        searchFunctionHelper.setQueryParameter(
          'highlightPreTag',
          '<span class="ais-highlight">'
        );
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate(isMobile ? 'instant_search_mobile' : 'instant_search'), 
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  if (instant.poweredBy) {
    // eslint-disable-next-line no-console
    console.log('Algolia: Instant-Search');
  }

  function readjust() {
    
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    isMobile = calculateScreenSize();
    if (showingMobileView != isMobile){
      console.log(`Changing to ${isMobile ? "mobile" : "desktop"} view`)
      renderInstantSearch();
    }
    
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        $button.addEventListener('click', function() {
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            $button.textContent = 'Show filters';
            $facets.classList.remove('ais-facets__shown');
          } else {
            $button.textContent = 'Hide filters';
            $facets.classList.add('ais-facets__shown');
          }
        });
      },
    },
  ]);


  

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        if (!instant.poweredBy) {
          document.querySelector('.ais-algolia-icon').style.display = 'none';
        }
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          if (instant.poweredBy) {
            document.querySelector('.ais-algolia-icon').style.display = '';
          }
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
          document.querySelector('.ais-algolia-icon').style.display = 'none';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document
          .querySelector('.ais-search-header .ais-change-display-block')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
          });
        document
          .querySelector('.ais-search-header .ais-change-display-list')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header">FILTERED BY</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });


  window.queryID = "";

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = '/collections/' + collectionHandle;
          }

          // Add the product handle to the link
          link = link + '/products/' + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {
            var clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
              positions: [Number(hit.dataset.algoliaPosition)],
            };

            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Pagination
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 2,
      maxPages: 20,
    }),
  ]);

  instant.search.addWidgets([
  queryRuleCustomData({
    container: '#custom-facets',
    templates: {
      default: '',
    },
    transformItems: function(items) {

      const match = items.find(data => Boolean(data.redirect));
      
      if (match && match.redirect) {
        window.location.href = match.redirect;
      }
      return [];
    },
  })
]);

      // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
      },
      transformItems: function(products) {

        let queryID = "";
        var numberProducts = products.length;
        var currentAjaxCall = 0;

        clearSliders();

        return products.map(function(product) {

          
        const saleBadge = `<div id="sale_badge_${product.id}"><div class="sale-badge">On Sale</div></div>`;
        const soldOutBadge = `<div id="sale_badge_${product.id}"><div class="sale-badge">Sold Out</div></div>`;
          
          
          //the template needs to be rerendered on filter if the swatch had been changed
          const existingSwatches = $(`.${product.id}_swatch`);
                if (existingSwatches[0] && !$(existingSwatches[0]).hasClass('selected')){

                  const index = $(existingSwatches[0]).attr("id").split('_')[1];
                  
                  currentAjaxCall ++;
                  changeActiveItem(`/products/${product.handle}`, index, product.id);
                  
                  return algolia.assign({}, product, {
                  _distinct: instant.distinct,
                  can_order:
                    product.inventory_management !== 'shopify' ||
                    product.inventory_policy === 'continue' ||
                    product.inventory_quantity > 0,
                  translations: algolia.translations,
                  queryID: product.__queryID,
                  productPosition: product.__position,
                  index: instant.search.mainIndex.getIndexName(),
                });
          }
          
          

            jQuery.ajax({
            url: '/products/' + product.handle + '.js',
            dataType: 'text json',
            error: function(err, ajaxOptions, thrownError){
              console.log(err);
              currentAjaxCall ++;
            },
            success: function(response)
            {
              try {

             currentAjaxCall ++;

            const bannerText = getBanner(response);
          if (bannerText){
            const bannerHtml = `
              <div class="limited-banner-container">
              ${bannerText} </div>`;
            $('#grid_item_' + product.id).prepend(bannerHtml)
            };

            buildCarousel(response);
            getMetafields(response);

            //if the slider needs to be reinitialised
              const thisSliderID = `tinySlider-contents_${product.id}`
              const thisSlider = document.getElementById(thisSliderID);
                if (thisSlider){
                    initSlider(thisSlider);
                }
              
            //get price in local presentment currency
            const priceSelector = document.getElementsByClassName('price_' + response.id)[0];
            const price = window.Shopify.formatMoney(response.price_min, `{{ amount }}`);
            let priceText = `${window.currencySymbol}`;
              priceText += `${price}`;

             if (response.available || response.tags.includes("COMING_SOON")) {
             priceSelector.innerText = priceText;
              
             priceText += ``

            if (response.compare_at_price_min === 0){
                //get sitewide sale price
                
              }
              else {
                //get regular sale price
                let compareText = `${window.currencySymbol}`;
                let comparePrice = response.compare_at_price_min;
                comparePrice = window.Shopify.formatMoney(comparePrice, `{{ amount }}`);
                compareText += comparePrice;

                const saleText = '<span class="ais-hit--price-striked">' + compareText + '</span>';
                priceSelector.innerHTML += saleText;
                $('#grid_item_' + product.id).prepend(saleBadge);
                }
                }

                else {
                  //sold out
                  priceSelector.innerText = "Sold out";
                  $('#grid_item_' + product.id).prepend(soldOutBadge);
                }


            //clear variants whenever the hits are reloaded (e.g after filter)
              if (document.getElementById('results-cart-selector_' + product.id !== null)) {
                document.getElementById('results-cart-selector_' + product.id).replaceChildren();
              }

            //if the variants aren't already populated
            if ($('#results-cart-selector_' + product.id)[0] != undefined){
            if ($('#results-cart-selector_' + product.id)[0].children.length == 0) {

                if (response.options?.length > 1) {
                //product has multiple options, deactivate quick selector
                let cartOption = `<div id="AddToCartForm"class="quick-add-to-cart clearfix AddToCartForm">
                                    <a tabindex="-1" href="/products/${product.handle}" style="display: block!important;" class="seeCartOptions">See Options</a>
                                  </div>`;
                    $('#results-cart-selector_' + product.id).append(cartOption);
                  }
                      else {
                        
                        for (let i = 0; i < response.variants.length; i++) {
            
                                    if (response.variants[i].available){
            
                                      let title = response.variants[i].title;
                                      if (title == 'Default Title'){
                                        title = 'OSFA';
                                      }
                                      
            
                                    let cartOption = `<form id="AddToCartForm" action="/cart/add" method="post" enctype="multipart/form-data" class="quick-add-to-cart clearfix AddToCartForm">
                                      <input tabindex="-1" type="hidden" name="id" value="${response.variants[i].id}">
                                      <input tabindex="-1" style="display: block!important;" type="submit" name="add" id="AddToCart" class="AddToCart" value="${title}">
                                    </form>`
            
                                    $('#results-cart-selector_' + product.id).append(cartOption);
            
                         }
                        }

                        const cart_spinner = `<div class="cart-lds-ring cart-spinner-collections" style="display: none"><div></div><div></div><div></div><div></div></div>`;
                        $('#results-cart-selector_' + product.id).append(cart_spinner);
          
            }

              $('#quick-shop-quickadd_' + product.id).on('click', function(e) {
                e.preventDefault();
                if ($(this).parent().hasClass("variants-options-on")) {
                    $(this).parent().removeClass('variants-options-on');
                } else {
                  $('.grid-view-item').removeClass('variants-options-on');
                    $(this).parent().addClass('variants-options-on');
                }
            });


              $('#results-cart-selector_' + product.id).on('click', function(){
                if (window.queryID !== ""){
                  window.sendAlgoliaConversionEvent(String(product.objectID), window.queryID); //this needs to be an algolia object id, not shopify id
                }
               });

          }}

                
          //call only after the last product is retrieved

          if (currentAjaxCall == numberProducts) {

            lazyLoadGalleries();
            document.addEventListener('scroll',function(){
              lazyLoadGalleries();
            });

            window.ajaxCart.init({
            formSelector: '.AddToCartForm',
            cartContainer: '#CartContainer',
            addToCartSelector: '#AddToCart',
            cartCountSelector: '#CartCount',
            moneyFormat: window.Currency ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format : window.default_currency_format
          });

          if (window.SwymCallbacks != undefined && window.SwymCallbacks != null){
          window.SwymCallbacks.push(function(swat){
            swat.initializeActionButtons('.ais-Hits')
          });
          }
          
          };

            }
              catch(e){
              console.log(e);
              }
              
          }});

          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            can_order:
              product.inventory_management !== 'shopify' ||
              product.inventory_policy === 'continue' ||
              product.inventory_quantity > 0,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
          });
 
          
        });

        
      },
    }),
  ]);

      instant.search.on('render', function(){

    $('html,body').scrollTop(0);

    loadFacets();
    closeAllFacets();
    renderFacetCount();
    renderFacetEvents();
    
    if (instant.search.helper.lastResults != null){
      window.queryID = instant.search.helper.lastResults.queryID;
    }

  });


  // Main
  instant.search.start();

}
  // end instant

  renderInstantSearch();
  


  function renderFacetCount(){
    if (document.getElementsByClassName('ais-current-refined-values--list')[0]){
      const count = document.getElementsByClassName('ais-current-refined-values--list')[0].children.length;

      const refinements = document.getElementById('ais-current-refined-values-container');
      if (count < 1){
        refinements.classList.remove('visible');
      }
      else {
        refinements.classList.add('visible');
      }
    
      document.getElementById('ais-facets-mobile-indicator').innerText = count;
      if (count > 0){
        document.getElementById('ais-facets-mobile-indicator').classList.add('visible');
      }
      else {
        document.getElementById('ais-facets-mobile-indicator').classList.remove('visible');
      }
    }
  }
  
function renderFacetEvents(){
  const nodes = $('.ais-facet--header')
    const array = Array.from(nodes);
    array.forEach(header => {
    
    $(header).click(function() {
      const id = $(this).attr('data-id');
      toggleFacets(id);
    })
  })
}

  function toggleFacets(dataId){

    let header = document.getElementById(`header_${dataId}`);
    let container = document.getElementById(`accordion_${dataId}`);
    
    if (container.classList.contains('open')){
      header.classList.remove('open');
      container.classList.remove('open');
    }
    else {
      header.classList.add('open')
      container.classList.add('open');
    }
  }
  
function getMetafields(product){
      // Add metafields below product

  let parentStoreUrl = "";
  if (window.theme?.storeHasSwatches === false){
    parentStoreUrl = 'https://thatssofetch.com.au';
  }

  $.ajax({
    url: parentStoreUrl + "/products/" + product.handle + "?view=metafields.json",
    success: function(resp){
      try {

        let j = JSON.parse(resp);


        function populateSwatches(usingCollection) {
          if (usingCollection){
            

            let products = j.swatches[0].collection[0].products;
            let urls = j.swatches[0].collection[1].urls;

            for (let i = 0; i< 8; i++){

          if (products[i]){

          var selected='';
          if (i == 0) {
            selected='selected';
          }
          else {
            selected = '';
          }

            let swatchHtml = '';

            //for the first item, use own product data
            if (i == 0){
              swatchHtml = `<a id="${product.id}_${i}" 
          onClick="changeActiveItem('${urls[0]}', '${i}', '${product.id}')"
          class="${product.id}_swatch collection-swatch ${selected}" style="background-color: ${products[0]}"><div class="swatch"></div></a>`;
            }
              
            //all other collection swatches
            else {


              //remove duplicate swatch from the collection data
            if (urls[0] == urls[i]){
                swatchHtml = '';
            }
              else {
                swatchHtml = `<a id="${product.id}_${i}" 
                onClick="changeActiveItem('${urls[i]}', '${i}', '${product.id}')"
                class="${product.id}_swatch collection-swatch ${selected}" style="background-color: ${products[i]}"><div class="swatch"></div></a>`;
              }

            }

          


        if ($('#swatches_' + product.id)){
          if (document.getElementById(product.id + '_' + i)){
          }
          else {
            $('#swatches_' + product.id).append(swatchHtml);
          }
        }
   
        };
        }

            
            
          }
          else {
            
          for (let i = 1; i<(j.swatches.length); i++){

          if (j.swatches[i].product[0].colour){

          var selected='';
          if (i == 1) {
            selected='selected';
          }
          else {
            selected = '';
          }

          let swatchHtml = `<a id="${product.id}_${i}" 
          onClick="changeActiveItem('${j.swatches[i].product[1].url}', '${i}', '${product.id}')"
          class="${product.id}_swatch collection-swatch ${selected}" style="background-color: ${j.swatches[i].product[0].colour}"><div class="swatch"></div></a>`;


        if ($('#swatches_' + product.id)){
          if (document.getElementById(product.id + '_' + i)){
          }
          else {
            $('#swatches_' + product.id).append(swatchHtml);
          }
        }
   
        };
        }
        }
        }

        
        window.theme.applyPreorderProperties(j.preorder);
        

        
        if (j.swatches[0].collection[0].products[1]){
          populateSwatches(true);
        }
        else {
          populateSwatches(false);
        }


      }
      catch(e){
        console.log(e)
      }
      
      }
  });

    
  }


  
  // Render galleries
  
  function loadGalleryImages(sliderDiv, numberToPreload, loadAll){


    const slides = sliderDiv.slides;

    if (slides?.length > 0){
    
    let imagesToPreload = numberToPreload;
    if (loadAll === true && slides.length > 0){
      imagesToPreload = slides.length;
    }
    
    for (let i=1; i < imagesToPreload + 1; i++){

      if (slides[i]){
          let image = slides[i].children[0];
          if (image){
            if ($(image).attr('data-srcset') !== undefined && $(image).attr('data-srcset') !== false){
            let dataSrc = $(image).attr('data-srcset');
            $(image).attr('srcset',dataSrc);
          }
          }
      }
    }
  }
  }



  var windowLoaded = false;

  if (isMobile){
    window.addEventListener('load',function(){
      loadAllFirstImages();
      windowLoaded = true;
    })
    }
  else {
    window.addEventListener('load',function(){
      windowLoaded = true;
    })
  }

  function async(u, c) {
    var d = document, t = 'script',
        o = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
    o.src = '//' + u;
    if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
    s.parentNode.insertBefore(o, s);
    };
  
  function loadSwiper(){
    async('cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js', function() {
    });
  }

  loadSwiper();

  function loadFirstGalleries() {

    console.log('loading first')
        function async(u, c) {
    var d = document, t = 'script',
        o = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
    o.src = '//' + u;
    if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
    s.parentNode.insertBefore(o, s);
    }

    

    let sliders = document.querySelectorAll('.swiper');
      
    for (let i =0; i<4; i++){
      initSlider(sliders[i]);
    }

        document.addEventListener('scroll',function(){
          lazyLoadGalleries();
        });

    
  }




  //get alternate size srcs to use in data src
function getSizes(src, size){

        //todo: add a custom placeholder image
        if (!src) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'medium') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '375x.progressive' + '.$2');
        }
        
        if (size === 'large') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '560x.progressive' + '.$2');
        }

        if (size === 'desktop') {
          return src.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '760x.progressive' + '.$2');
        }
        
        return src;

};

  var imageLoaded = 0;  
  
  function buildCarousel(data){


  imageLoaded ++;  
  
  var html = `<div class="swiper-wrapper tinySlider-container_${data.id} tinySlider-container" style="position: absolute; top: 0; left: 0;">`;
  
  let numberImages = 6;
  if (data.images.length < 6) {
    numberImages = data.images.length;
  }

    let initialLoad = 2;
    if (isMobile){
       initialLoad = 3;
    }

  
    
  for (let i = 0; i < numberImages; i++){
  
    // mobile = 670px width and below
    var mobile = getSizes(data.images[i], 'large');
    var mobileLrg = getSizes(data.images[i], 'large');
    var desktop = getSizes(data.images[i], 'desktop');
    var original = data.images[i];
  
    const classVar = `class="main-interactive"`;
    
    
    if (i < initialLoad){
      html += `<a class="swiper-slide mobile-img-active" href="${data.url}"><img srcset="${desktop} 760w,
               ${mobileLrg} 560w, ${mobile} 375w" 
                 sizes="(min-width: 1300px) 760px, 49vw"></a>`;
    }
    else {
      html += `<a class="swiper-slide mobile-img-active" href="${data.url}"><img data-srcset="${desktop} 760w,
               ${mobileLrg} 560w, ${mobile} 375w" 
                 sizes="(min-width: 1300px) 760px, 49vw"></a>`;
    }
  
  }
  
  html += `</div>`;

  document.getElementById('tinySlider-contents_' + data.id).innerHTML = html;
    
  }

  function isOnScreen(element){
    const el = element.getBoundingClientRect();
    var height = Math.max(document.documentElement.clientHeight, window.innerHeight);

    if (el.bottom < 0 || el.top - (height * 4) >= 0){
      return false;
    }
  else return true;
  }
 var sliderList = []
  
  function lazyLoadGalleries() {

    let slider = document.querySelectorAll('.swiper');
    for (let i=0; i<slider.length; i++){

    if (isOnScreen(slider[i]) && !($(slider[i]).hasClass('rendered'))){
      initSlider(slider[i]);
    }
  };
    
  }
  


  function getBanner(product){
    if (product.tags.includes('trending')){
      return `<div class="limited-banner-product boost"><p class="limited-banner-product-text trending">TRENDING</p></div>`;
    }
  if (product.tags.includes('limitededition')){
    return `<div class="limited-banner-product boost"><p class="limited-banner-product-text">LIMITED EDITION</p></div>`;
  };
  if (product.tags.includes('TSFEXCLUSIVE')){
    return `<div class="limited-banner-product boost"><p class="limited-banner-product-text">TSF EXCLUSIVE</p></div>`;
  };
  if (product.tags.includes('COMING_SOON')){
    return `<div class="limited-banner-product coming-soon boost"><p class="limited-banner-product-text coming-soon">COMING SOON</p></div>`;
  };
  if (product.tags.includes('PREORDER')){
    return `<div class="limited-banner-product boost"><p class="limited-banner-product-text preorder">PRE-ORDER</p></div>`;
  };
  }

  function initSlider(sliderEl){
   if (!sliderEl){
         return;
    }

    const prevNode = sliderEl.parentNode?.querySelector('.tinySlider-prevButton');
    const nextNode = sliderEl.parentNode?.querySelector('.tinySlider-nextButton');

    let swiper = new Swiper(sliderEl, {
    slidesPerView: 1,
    navigation: {
      nextEl: nextNode,
      prevEl: prevNode,
    },
    speed: 300,
      createElements: true,
    resistance: true,
    threshold: 10,
    touchAngle: 50,
    allowTouchMove: true,
    slideToClickedSlide: true,
    initialSlide: 0,
    on: {
      afterInit: function(e) {
        document.getElementById(e.el.id).classList.add('rendered');
        document.getElementById(e.el.id).classList.add('visible');
      },
      slideChange: function(e){
        loadGalleryImages(e, 1, true);
      }
    },
    autoHeight: false,
    loop: false,
    breakpoints: {
      10: {
        slidesPerView: 1,
        navigation: {
      nextEl: nextNode,
      prevEl: prevNode,
        }
      },
      900: {
        slidesPerView: 1,
         navigation: {
          nextEl: nextNode,
          prevEl: prevNode,
          },
        slideToClickedSlide: false,
        centeredSlides: false,
      },
      1300: {
        navigation: {
      nextEl: nextNode,
      prevEl: prevNode,
          },
        slidesPerView: 1,
      },
    },
  });
  }

  function clearSliders(){
    const sliders = $('.swiper');
        sliders.removeClass('rendered')
        sliders.removeClass('swiper-initialized')
        sliders.removeClass('visible');
  }
  



  

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
